import React from "react";
import { CasesDetailsConsumer } from "../../../../context/casesDetailsContextProvider";
import { dbDateStringToLocalDate } from "../../../shared/helpers/dates";

export default function Logs() {
  return (
    <CasesDetailsConsumer>
      {(context) => (
        <>
          <div className="content-container p-3">
            <table className="table">
              <thead>
                <tr>
                  <th>Action</th>
                  <th>User</th>
                  <th>Timestamp</th>
                </tr>
              </thead>
              <tbody>
                {context.state.logs.map((log: any, index: number) => {
                  return (
                    <tr key={index} title={log.logInformation}>
                      <td>{log.logMessage}</td>
                      <td>{log.logBy}</td>
                      <td>{dbDateStringToLocalDate(log.logTime).toLocaleString()}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </>
      )}
    </CasesDetailsConsumer>
  );
}
